// extracted by mini-css-extract-plugin
module.exports = {"Form":"contactForm_Form__Lvq-d","FormLabel":"contactForm_FormLabel__3LVgh","FormInput":"contactForm_FormInput__Q3gcM","FormButton":"contactForm_FormButton__3973M"};